import { fromJS, List } from 'immutable';

import {
  SET_CONTRACTS_TYPE,
  GET_CONTRACTS_TYPE,
  MATCH_CONTRACT_SUCCESS,
  GET_CONTRACTS_AUTO,
  SET_CONTRACTS_AUTO,
  GET_CONTRACTS_AUTO_FAILED,
  SET_CONTRACT_INFO,
  GET_CONTRACT_DETAIL,
  GET_CONTRACT_DETAIL_FAILED,
  SET_CONTRACT_DETAIL,
  SET_CONTRACT_DETAIL_FILES,
  SET_CONTRACT_DETAIL_SERVICES,
  SET_CONTRACT_DETAIL_GARANTIES,
  GET_CONTRACTS_MRH,
  SET_CONTRACTS_MRH,
  GET_CONTRACTS_MRH_FAILED,
  ADD_NEW_CONTRACT,
  ADD_NEW_CONTRACT_FAILED,
  OPEN_MODAL_SUCCESS_CONTRACT,
  CLOSE_MODAL_SUCCESS_CONTRACT,
  OPEN_ADD_NEW_CONTRACT_MODAL,
  CLOSE_ADD_NEW_CONTRACT_MODAL,
  GET_DETAILS_CONTRACT_MRH,
  SET_DETAILS_CONTRACT_MRH,
  SET_DETAILS_CONTRACT_MRH_FAILED,
  SET_DETAILS_CONTRACT_MRH_GARANTIES,
  SET_DETAILS_CONTRACT_MRH_FILES,
  GET_CONTRACTS_EPARGN,
  SET_CONTRACTS_EPARGN,
  GET_CONTRACTS_EPARGN_FAILED,
  GET_PRODUIT_EPARGN,
  SET_PRODUIT_EPARGN_SUCCESS,
  GET_PRODUIT_EPARGN_FAILED,
  SET_AUTH_CONTRACT_EPARGN_INFO,
  SET_CONTRACTS_AMC,
  GET_CONTRACTS_AMC,
  GET_CONTRACTS_AMC_FAILED,
  SET_CONTRACT_AMC_BENEFICIARIES,
  GET_CONTRACT_AMC_BENEFICIARIES_FAILED,
  SET_CLIENT_CONTRACT_ASI,
  SET_CONTRACTS_AMC_DETAIL,
} from 'store/contract/constants';
import { ContractActionType } from 'store/contract/actions';

export const initialState = fromJS({
  contractsType: [],
  typeContract: '',
  key1: '',
  key2: '',
  key3: '',
  isLoadingContract: false,
  isLoading: false,
  errorMessageGetContract: null,
  contractsAuto: [],
  errorContractsAuto: null,
  numPolice: null,
  dateEcheance: null,
  type: null,
  detailContract: '',
  isLoadingContractDetail: false,
  hasErrorContractDetail: false,
  files: [],
  servicesAssitance: [],
  garantiesAuto: [],
  isLoadingContractMrh: false,
  contractsMRH: [],
  errorMessageGetContractMRH: null,
  errorMessageAddContract: null,
  openModalSucces: false,
  isOpenAddNewContractModal: false,
  detailContractMRH: '',
  garantiesMrh: [],
  errorGetDetailsMrh: null,
  isLoadingGetDetailsMrh: false,
  filesMrh: [],
  isLoadingContractEpargn: false,
  contractsEpargn: [],
  errorGetContractsEpargn: null,
  isLoadingProduct: false,
  product: [],
  errorGetProduct: null,
  authContratEpargn: null,
  isLoadingContractsAMC: false,
  contractsAMC: [],
  contractsAMCDetail: [],
  errorMessageGetContractsAMC: null,
  beneficiaries: [],
  errorMessageGetContractAMCBeneficiaries: null,
  contractsASI: [],
});
export default function reducer(
  state = initialState,
  action: ContractActionType,
) {
  switch (action.type) {
    case SET_CONTRACT_INFO:
      return state.merge(action.payload);
    case SET_AUTH_CONTRACT_EPARGN_INFO:
      return state.set('authContratEpargn', action.payload);
    case GET_CONTRACTS_TYPE:
      return state
        .set('isLoadingContract', true)
        .set('errorMessageGetContract', null);
    case SET_CONTRACTS_TYPE:
      return state
        .set('contractsType', action.payload)
        .set('isLoadingContract', false);
    case MATCH_CONTRACT_SUCCESS:
      return state.merge(action.payload, { isLoading: false });
    case GET_CONTRACTS_AUTO:
      return state.set('isLoadingContract', true);
    case SET_CONTRACTS_AUTO:
      return state
        .set('contractsAuto', action.payload)
        .set('isLoadingContract', false);
    case GET_CONTRACTS_AUTO_FAILED:
      return state.set('errorContractsAuto', action.payload);
    case GET_CONTRACT_DETAIL:
      return state
        .set('isLoadingContractDetail', true)
        .set('hasErrorContractDetail', null);
    case GET_CONTRACT_DETAIL_FAILED:
      return state
        .set('isLoadingContractDetail', false)
        .set('hasErrorContractDetail', true);
    case SET_CONTRACT_DETAIL:
      return state
        .set('detailContract', action.payload)
        .set('isLoadingContractDetail', false);
    case SET_CONTRACT_DETAIL_FILES:
      return state.set('files', action.payload);
    case SET_CONTRACT_DETAIL_SERVICES:
      return state.set('servicesAssitance', action.payload);
    case SET_CONTRACT_DETAIL_GARANTIES:
      return state.set('garantiesAuto', action.payload);
    case GET_CONTRACTS_MRH:
      return state.set('isLoadingContractMrh', true);
    case SET_CONTRACTS_MRH:
      return state
        .set('contractsMRH', action.payload)
        .set('isLoadingContractMrh', false);
    case GET_CONTRACTS_MRH_FAILED:
      return state.set('errorMessageGetContractMRH', action.payload);
    case ADD_NEW_CONTRACT:
      return state.set('isLoading', true);
    case ADD_NEW_CONTRACT_FAILED:
      return state.set('errorMessageAddContract', action.payload);
    case OPEN_MODAL_SUCCESS_CONTRACT:
      return state.set('openModalSucces', true);
    case CLOSE_MODAL_SUCCESS_CONTRACT:
      return state.set('openModalSucces', false);
    case OPEN_ADD_NEW_CONTRACT_MODAL:
      return state.set('isOpenAddNewContractModal', true);
    case CLOSE_ADD_NEW_CONTRACT_MODAL:
      return state.set('isOpenAddNewContractModal', false);
    case GET_DETAILS_CONTRACT_MRH:
      return state.set('isLoadingGetDetailsMrh', true);
    case SET_DETAILS_CONTRACT_MRH:
      return state
        .set('detailContractMRH', action.payload)
        .set('isLoadingGetDetailsMrh', false);
    case SET_DETAILS_CONTRACT_MRH_FAILED:
      return state.set('errorGetDetailsMrh', action.payload);
    case SET_DETAILS_CONTRACT_MRH_GARANTIES:
      return state.set('garantiesMrh', action.payload);
    case SET_DETAILS_CONTRACT_MRH_FILES:
      return state.set('filesMrh', action.payload);
    case GET_CONTRACTS_EPARGN:
      return state.set('isLoadingContractEpargn', true);
    case SET_CONTRACTS_EPARGN:
      return state
        .set('contractsEpargn', fromJS(action.payload))
        .set('isLoadingContractEpargn', false);
    case GET_CONTRACTS_EPARGN_FAILED:
      return state.set('errorGetContractsEpargn', action.payload);
    case GET_PRODUIT_EPARGN:
      return state.set('isLoadingProduct', true);
    case SET_PRODUIT_EPARGN_SUCCESS:
      return state
        .set('product', action.payload)
        .set('isLoadingProduct', false);
    case GET_PRODUIT_EPARGN_FAILED:
      return state
        .set('errorGetProduct', action.payload)
        .set('isLoadingProduct', false);

    case GET_CONTRACTS_AMC:
      return state.set('isLoadingContractsAMC', true);
    case SET_CONTRACTS_AMC:
      return state
        .set('contractsAMC', List(action.payload))
        .set('isLoadingContractsAMC', false);
    case GET_CONTRACTS_AMC_FAILED:
      return state
        .set('errorMessageGetContractsAMC', action.payload)
        .set('isLoadingContractsAMC', false);
    case SET_CONTRACT_AMC_BENEFICIARIES:
      return state.set('beneficiaries', List(action.payload));
    case GET_CONTRACT_AMC_BENEFICIARIES_FAILED:
      return state.set(
        'errorMessageGetContractAMCBeneficiaries',
        action.payload,
      );
    case SET_CLIENT_CONTRACT_ASI:
      return state.set('contractsASI', fromJS(action.payload));
    case SET_CONTRACTS_AMC_DETAIL:
      return state.set('contractsAMCDetail', List(action.payload));
    default:
      return state;
  }
}
